// extracted by mini-css-extract-plugin
module.exports = {"workPiece":"WorkPiece_workPiece__4WP6e","svg":"WorkPiece_svg__3nOfW"};